import { useQuery } from 'react-query'

import { QueryNames } from 'Hooks/api/queryNames'
import { useErrorReporter } from 'Hooks/useErrorReporter'

import { getAdminAccountDetails } from 'Services/JOONAdmin/joonAdminUsersService'

export const useGetAdminAccountDetailsQuery = (userId: number) => {
  const reportError = useErrorReporter()

  return useQuery({
    cacheTime: 1,
    queryKey: [QueryNames.GetAdminAccountDetails, userId],
    queryFn: async () => {
      const response = await getAdminAccountDetails(userId)

      if (response.data) {
        return response.data
      } else {
        reportError('useGetAdminAccountDetailsQuery failure', response)
        throw new Error(response.message || 'Failed to load account details')
      }
    }
  })
}
